<!-- routify:options index=2 -->
<script lang="ts">
  import Uniapp from '../components/uniapp.svelte';
  import MdIntegrations from '../components/md-integrations.svelte';
  import Wellabe from '../components/wellabe.svelte';
  import Fprj from '../components/fprj.svelte';
  import IntersectionObserver from 'svelte-intersection-observer';
  import { setHeaderColor } from '../shared/header-store';
  import { onDestroy } from 'svelte';
  import { trackViewSection } from '../shared/utils';
  import FooterSection from '../components/home/footer-section.svelte';

  let element: HTMLElement[] = [];
  let intersecting: boolean[] = [];
  let isObserverDirty: boolean = false;

  onDestroy(() => {
    isObserverDirty = false;
  });

  function setHeaderTheme(theme: string, background: string) {
    if (!isObserverDirty) {
      isObserverDirty = true;
      return;
    }

    setHeaderColor(theme, background, '/work');
  }
</script>

<div class="block h-screen bg-wellabe-bg-medium">
  <IntersectionObserver
    element={element[0]}
    bind:intersecting={intersecting[0]}
    on:intersect={() => {
      if (intersecting[0]) {
        setHeaderTheme('purple', 'wellabe-light');
        trackViewSection('work-wellabe-section');
      }
    }}
  >
    <Wellabe bind:element={element[0]} />
  </IntersectionObserver>

  <IntersectionObserver
    element={element[1]}
    bind:intersecting={intersecting[1]}
    on:intersect={() => {
      if (intersecting[1]) {
        setHeaderTheme('uniapp', 'uniapp');
        trackViewSection('work-uniapp-section');
      }
    }}
  >
    <Uniapp bind:element={element[1]} />
  </IntersectionObserver>

  <IntersectionObserver
    element={element[2]}
    bind:intersecting={intersecting[2]}
    on:intersect={() => {
      if (intersecting[2]) {
        setHeaderTheme('fprj', 'fprj');
        trackViewSection('work-fprj-section');
      }
    }}
  >
    <Fprj bind:element={element[2]} />
  </IntersectionObserver>

  <IntersectionObserver
    threshold={0}
    element={element[3]}
    bind:intersecting={intersecting[3]}
    on:observe={() => {
      if (intersecting[3]) {
        setHeaderTheme('black', 'md-integrations-light');
        trackViewSection('work-mdi-section');
      }
    }}
  >
    <MdIntegrations bind:element={element[3]} />
  </IntersectionObserver>
  
  <FooterSection bind:element={element[4]} />

</div>
